import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  status: "idle",
  error: null,
  message: null,
};

export const updateLinkRoleSlice = createSlice({
  name: "updateLinkRole",
  initialState,
  reducers: {
    updateLinkRoleRequested: (state) => {
      state.status = "loading";
      state.error = null;
      state.message = null;
    },
    updateLinkRoleRequestFailed: (state, action) => {
      state.status = "failed";
      state.error = action.payload;
    },
    updateLinkRoleRequestSucceeded: (state, action) => {
      state.status = "succeeded";
      state.message = action.payload;
    },
    resetUpdateLinkRoleState: (state) => {
      state.status = "idle";
      state.error = null;
      state.message = null;
    },
  },
});

export const {
  updateLinkRoleRequested,
  updateLinkRoleRequestFailed,
  updateLinkRoleRequestSucceeded,
} = updateLinkRoleSlice.actions;

export default updateLinkRoleSlice.reducer;
